import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SendDataServiceService } from '../../../services/send-data-service.service';

@Component({
  selector: 'app-button-cellrenderer',
  templateUrl: './button-cellrenderer.component.html',
  styleUrls: ['./button-cellrenderer.component.scss']
})
export class ButtonCellrendererComponent implements ICellRendererAngularComp {
  params;
  genrateBillNo: boolean = false;
  isbtnshow:boolean=true;
  selectedDate :Date|null | string;
  today = new Date().toISOString().split('T')[0];
  constructor(public sendDataServiceService: SendDataServiceService) { }
  ngOnInit(): void {}
  agInit(params: ICellRendererParams<any, any>): void {
  this.params = params;
}
refresh(params: ICellRendererParams<any, any>): boolean {
  this.params = params;
  return false
}
onButtonClicked(params): void {
  this.sendDataServiceService.triggerButtonClick(params);
}
  onStatusIconClick(params) {
    params.api.deselectAll();
    params.node.setSelected(true);
    const customStatusEvent = new CustomEvent('StatusButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(customStatusEvent);
  }
 onExtendSubscription() {
  this.isbtnshow = false;
  const renewalDateStr = this.params?.data?.renewalDate;
  if (renewalDateStr) {
    this.selectedDate = renewalDateStr.substring(0, 10);
  } else {
    this.selectedDate = ''; 
  }
}
  onSave() {
    this.isbtnshow = true;
    const customDateEvent = new CustomEvent('onSaveExtendSubscription', {
    detail: { paramsdata: this.params.data ,extendedDate:this.selectedDate},
    });
    this.params.api.dispatchEvent(customDateEvent);
    this.selectedDate=null

}

  onCancel(){
   this.isbtnshow=true;
   this.selectedDate=null
  }

isValidDate() {
  if (!this.selectedDate) return false;
  const selected = new Date(this.selectedDate).toISOString().split('T')[0];
  return selected >= this.today;  
}
  
}
